/* eslint-disable @typescript-eslint/no-explicit-any */
import { TIconNames } from 'components/Base/Icon';
import { FC } from 'react';

export type PublicRouteType = {
  component: FC<any>;
  path: string;
  index?: boolean;
};

export type PrivateRouteType = PublicRouteType & {
  title?: string;
  icon?: TIconNames;
  subRoutes?: PrivateRouteType[];
  show?: boolean;
  // roles: TUserRoleUi[];
};

export enum RoutesPaths {
  REDIRECT = 'redirect',
  CERTIFICATE = 'certificate/:courseId/:checkpointKey',
  RESET_PASSWORD = 'reset-password',
  PAGE_NOT_FOUND = '404',
  APPLICATIONS = 'applications',
  VISITATIONS = 'visitations',
  ANIMALS = 'animals',
  TENANTS = 'tenants',
  FAQ = 'faq',
  ANALYTICS = 'analytics',
  SUGGESTED_TEXTS = 'suggested-texts',
  DOCUMENT_UPLOAD = 'documents',
  CURRICULUM = 'curriculum',
  LANDLORD = 'landlord',
  INTEGRATION = 'integration',
  PROFILE = 'profile',
}
